<template>
  <div>
    <div style="height:calc(100vh - 120px)" ref="sectorGrid"></div>
  </div>
</template>
<script>
import $ from '../../helpers/jquery-bridge'
import {enableExportExcel} from '../../helpers/export-helper'
import {jsonDropDownEditor} from '../../helpers/kendo-editors'
import {mapGetters} from 'vuex'
import {numericEditor, datePickerEditor} from '@/helpers/kendo-editors'
import security from '@/mixins/security'

export default {
  mixins: [security],
  mounted() {
    let vm = this
    let grid = $(this.$refs.sectorGrid)
      .kendoGrid({
        dataSource: new kendo.data.DataSource({
          type: 'aspnetmvc-ajax',
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
          pageSize: 15,
          transport: {
            create: {
              type: 'POST',
              url: '/api/config/sector',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
            read: {
              type: 'GET',
              url: '/api/config/sector',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
            update: {
              type: 'PUT',
              url: '/api/config/sector',
              data: () => ({clientId: this.clientId}),
              dataType: 'json',
            },
            destroy: {
              type: 'DELETE',
              url: '/api/config/sector',
              dataType: 'json',
            },
          },
          schema: {
            data: 'data',
            errors: 'errors',
            total: 'total',
            model: {
              id: 'sectorId',
              fields: {
                code: {type: 'string', validation: {required: true}},
                sectorName: {type: 'string', validation: {required: true}},
                curveId: {type: 'number', defaultValue: -1, validation: {required: true}},
                curveName: {type: 'string', defaultValue: 'NA', validation: {required: false}},
                canDelete: {type: 'boolean', defaultValue: true, editable: false},
              },
            },
          },
          error: function() {
            grid.one('dataBinding', e => {
              e.preventDefault()
            })
          },
        }),
        toolbar: !vm.isReadOnly ? ['create'] : [],
        editable: !vm.isReadOnly && 'inline',
        filterable: true,
        sortable: true,
        pageable: true,
        detailInit: this.detailInit,
        columns: [
          {
            command: [{name: 'edit'}],
            width: 82,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
          {
            title: 'Code',
            field: 'code',
            width: 150,
            editor:
              '<input id="code" name="code" required="required" type="text" class="k-input k-textbox" data-bind="value:code" maxlength="50">',
          },
          {
            title: 'Name',
            field: 'sectorName',
            width: 300,
            editor:
              '<input id="sectorName" name="sectorName" required="required" type="text" class="k-input k-textbox" data-bind="value:sectorName" maxlength="100">',
          },
          {
            title: 'Curve',
            field: 'curveName',
            template: '#=curveName#',
            width: 300,
            editor: jsonDropDownEditor(
              'curveId',
              'curveName',
              '/api/config/sector/getCurves',
              {},
              false,
            ),
          },
          {
            command: [{name: 'destroy', visible: dataItem => dataItem.canDelete}],
            width: 82,
            attributes: {style: 'text-align: center;'},
            hidden: vm.isReadOnly,
          },
          {},
        ],
      })
      .getKendoGrid()

    enableExportExcel(grid, '/api/config/sector/exportToExcel')
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
  },
  methods: {
    detailInit(e) {
      const sectorId = e.data.sectorId

      let subGrid = $('<div/>')
        .appendTo(e.detailCell)
        .kendoGrid({
          navigatable: true,
          toolbar: !this.isReadOnly ? ['create'] : '',
          editable: !this.isReadOnly && 'inline',
          dataSource: {
            type: 'aspnetmvc-ajax',
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            pageSize: 10,
            transport: {
              create: {
                type: 'POST',
                url: '/api/config/sector/createDetail',
                data: () => ({clientId: this.clientId}),
                dataType: 'json',
              },
              read: {
                type: 'GET',
                url: '/api/config/sector/readDetail',
                data: () => ({sectorId: sectorId}),
                dataType: 'json',
              },
              update: {
                type: 'PUT',
                url: '/api/config/sector/updateDetail',
                data: () => ({clientId: this.clientId}),
                dataType: 'json',
              },
              destroy: {
                type: 'DELETE',
                url: '/api/config/sector/destroyDetail',
                dataType: 'json',
              },
            },
            schema: {
              data: 'data',
              total: 'total',
              model: {
                id: 'sectorTaxId',
                fields: {
                  sectorTaxId: {type: 'number'},
                  sectorId: {type: 'int', editable: false, defaultValue: e.data.sectorId},
                  taxRate: {type: 'number', validation: {required: true}},
                  applicableDate: {type: 'date', validation: {required: true}},
                },
              },
            },
            error: function() {
              subGrid.one('dataBinding', function(er) {
                er.preventDefault()
              })
            },
          },
          filterable: true,
          sortable: true,
          pageable: true,
          columns: [
            {command: 'edit', title: '&nbsp;', width: 55, hidden: this.isReadOnly},
            {
              field: 'taxRate',
              title: 'Tax Rate(%)',
              width: '132px',
              format: '{0:P2}',
              editor: numericEditor(
                {
                  format: 'P2',
                  decimals: 4,
                  factor: 100,
                  spinners: false,
                  step: 0,
                },
                true,
              ),
            },
            {
              field: 'applicableDate',
              title: 'Applicable Date',
              width: '150px',
              attributes: {style: 'text-align: left;'},
              format: '{0:yyyy-MM-dd}',
              template: '#= kendo.toString(applicableDate, "yyyy-MM-dd") #',
              editor: datePickerEditor({format: 'yyyy-MM-dd'}, true),
            },
            {
              command: [{name: 'destroy'}],
              width: 82,
              attributes: {style: 'text-align: center;'},
              hidden: this.isReadOnly,
            },
            {},
          ],
        })
    },
  },
}
</script>
